export interface NavSubItem {
  label: string
  href?: string
  description?: string
  icon?: string
}

export interface NavCard {
  title: string
  description: string
  href: string
  image?: string // Placeholder for now
  subItems?: NavSubItem[]
}

export interface NavItem {
  label: string
  href?: string
  hasDropdown?: boolean
  tagline?: string
  cards?: NavCard[]
}

export const navigationConfig: NavItem[] = [
  {
    label: 'Product',
    href: '/platform/'
  },
  {
    label: 'Solutions',
    hasDropdown: true,
    cards: [
      {
        title: 'Pepper SEO + GEO',
        href: '/solutions/seo/',
        description:
          'Grow visibility across Google, YouTube, and AI platforms with precision. We blend search strategy, expert-driven optimization, and continuous optimization to keep your brand discoverable across every search surface.',
        image: '/assets/inc/nav/solutions__pepper-seo-geo.png'
      },
      {
        title: 'Pepper Creative',
        href: '/video-services/', // temp
        description:
          'Bring your brand to life with insight-led storytelling. Creative directors, designers, and copy specialists craft campaigns powered by AI agents and grounded in strategy - built to connect and convert.',
        image: '/assets/inc/nav/solutions__pepper-creative.png'
      },
      {
        title: 'Pepper Content',
        href: '/solutions/content/',
        description:
          'Turn ideas into revenue-driving content. From strategy to creation, our AI-assisted workflows and expert-led approach deliver stories that build authority, trust, and organic growth.',
        image: '/assets/inc/nav/solutions__pepper-content.png'
      },
      {
        title: 'Pepper AI',
        href: '/solutions/ai/',
        description:
          'Infuse intelligence into every workflow. Our strategists and technologists use AI to streamline production, unlock scale faster, and measure content impact with clarity.',
        image: '/assets/inc/nav/solutions__pepper-ai.png'
      },
      {
        title: 'Industries',
        href: '#',
        description: '',
        subItems: [
          {
            label: 'B2B SaaS',
            href: '/industries/b2b-saas/',
            icon: '/assets/inc/nav/b2b-software.svg',
            description: ''
          },
          {
            label: 'BFSI',
            href: '/industries/bfsi/',
            icon: '/assets/inc/nav/banking.svg',
            description: ''
          },
          {
            label: 'CPG & Retail',
            href: '/industries/fmcg-cpg/',
            icon: '/assets/inc/nav/retail.svg',
            description: ''
          },
          {
            label: 'Consumer Tech',
            href: '#', // Coming soon
            icon: '/assets/inc/nav/consumer.svg',
            description: ''
          }
        ]
      }
    ]
  },
  {
    label: 'Resources',
    hasDropdown: true,
    cards: [
      {
        title: 'Customer Stories',
        href: '/case-study/',
        description: 'Real results from leading brands',
        image: '/assets/inc/nav/customer-stories.png'
      },
      {
        title: 'Careers & Culture',
        href: '/careers',
        description: 'Build the future of marketing.',
        image: '/assets/inc/nav/careers-culture.png'
      },
      {
        title: 'Blogs & Insights',
        href: '/blog',
        description: 'Ideas shaping content and creativity.',
        image: '/assets/inc/nav/blogs-insights.png'
      },
      {
        title: 'About Us',
        href: '/about-us',
        description: 'Who we are and what drives us.',
        image: '/assets/inc/nav/about-us.png'
      },
      {
        title: 'Index’26 Bengaluru',
        href: 'https://index-26.pepper.inc/',
        description: "India's First GEO Growth Summit · July 2026 · Bengaluru",
        image: '/assets/inc/nav/index26.png'
      }
    ]
  },
  {
    label: 'Talent Marketplace',
    hasDropdown: true,
    cards: [
      {
        title: 'On-demand Experts for high-quality content',
        href: '/product/talent-marketplace/',
        description:
          'Access world-class content specialists on demand. Expert-crafted, brand-ready content delivered at speed across every industry and format.',
        image: '/assets/inc/nav/talent-on-demand.png'
      },
      {
        title: 'Top 3% Talent',
        href: '/blog/editorial-excellence-how-we-find-the-best-writers-on-our-platform/',
        description:
          'Hire only the best. Our rigorous vetting ensures you work with the top 3% of global creative and marketing talent.',
        image: '/assets/inc/nav/top3-talent.png'
      },
      {
        title: 'Apply as a Creator',
        href: '/product/creator/',
        description:
          "Join Pepper's elite creator network. Work with leading global brands and create at the cutting edge of AI-assisted tools and platforms.",
        image: '/assets/inc/nav/top3-talent.png'
      }
    ]
  }
]

export const ctaButtons = [
  {
    label: 'Log In',
    href: '/login',
    variant: 'secondary' as const
  },
  {
    label: 'Book a Demo',
    href: '/contact-us',
    variant: 'tertiary' as const
  }
]
